import { Button } from "flowbite-react"
import React, { ReactNode } from "react"

import { NoResultsIcon } from "@assets/icons"

interface EmptyItemsProps {
  title: string
  action?: {
    label: string | ReactNode
    handleClick?: () => void
  }
  className?: string
  icon?: ReactNode
}

const EmptyItems = ({ title, action, className, icon }: EmptyItemsProps) => {
  return (
    <div
      className={`my-auto flex w-full flex-col items-center justify-center gap-4 ${className ?? ""}`}
    >
      {icon || <NoResultsIcon />}
      {title && <p className={"paragraph14Regular text-center text-neutral-900"}>{title}</p>}
      {action && (
        <Button outline size={"md"} onClick={() => action.handleClick?.()} className={"mt-2"}>
          {action.label}
        </Button>
      )}
    </div>
  )
}

export default EmptyItems
